import { MedicalCheckupModel } from 'src/app/core/models/medical-checkup.model';

export class SetCurrentMedicalCheckup {
  static readonly type = '[medical-checkup] Set current medical checkup';

  constructor(public readonly payload: MedicalCheckupModel) {}
}
